import s from './Button.module.sass'

import React, { forwardRef } from 'react'

import { useCurrentSize } from '@shared/lib/helpers/classes'
import LinkButton from './LinkButton'
import { LoadingSpinner } from '@shared/ui/Feedback/LoadingSpinner'

type ComponentExtensions = {
  Link: typeof LinkButton
}

export interface ButtonBaseProps {
  sizes: string
  isLoading?: boolean
  mode: 'white' | 'white-border' | 'white-shadow' | 'yellow-border' | 'black' | 'red-link' | 'ghost'
  className?: string
}
type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & ButtonBaseProps
type ButtonComponent = React.ForwardRefExoticComponent<ButtonProps> & ComponentExtensions

const loaderSizes = {
  XS: 12,
  S: 16,
  M: 20,
  L: 24,
  XL: 32,
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ sizes, mode, className = '', children, isLoading = false, ...props }, ref) => {
    const [size] = useCurrentSize(sizes)
    return (
      <button
        type='button'
        data-size={size}
        data-mode={mode}
        className={`${s.button} ${className}`}
        // @ts-ignore
        ref={ref}
        {...props}>
        <div className={s.button__content}>
          {isLoading ? (
            // т.к. цвета лоудера везде совпадали с цветом текста можно просто спускать его, но имейте сам факт в виду
            <LoadingSpinner loading={isLoading} size={loaderSizes[size]} iconColor='currentColor' />
          ) : (
            children
          )}
        </div>
      </button>
    )
  },
) as ButtonComponent

Button.Link = LinkButton

Button.displayName = 'Button'

export default Button
